import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';
import { CurrencyFormat } from '../../waitingnotes.component';

export interface FreeAmountDialogData {
  totalAmount: number;
  currencyFormat: CurrencyFormat;
}

@Component({
  selector: 'app-free-amount-dialog',
  templateUrl: './free-amount-dialog.component.html',
  styleUrls: ['./free-amount-dialog.component.css']
})
export class FreeAmountDialogComponent {
  freeAmount = 0;

  constructor(
    public dialogRef: MatDialogRef<FreeAmountDialogComponent>,
    public cssService: CssService,
    @Inject(MAT_DIALOG_DATA) public data: FreeAmountDialogData
  ) { }

  isClosing = false;
  selectedOption: number | null = null;

  ngOnInit(): void {
    this.freeAmount = this.roundedThisNumber(this.data.totalAmount);
  }

  roundedThisNumber(thisNumber: number) {
    return Math.round(thisNumber * 100) / 100;
  }

  isFreeAmountValid(): boolean {
    return this.freeAmount !== null && this.freeAmount >= 1.00;
  }

  decreasePaidAmount(): void {
    if (this.freeAmount >= 0.50) {
      this.freeAmount -= 0.50;
      this.freeAmount = this.roundedThisNumber(this.freeAmount);
    } else {
      this.freeAmount = 0.00;
    }
  }

  increasePaidAmount(): void {
    if (this.freeAmount < this.data.totalAmount) {
      if (this.freeAmount + 0.50 > this.data.totalAmount) {
        this.freeAmount = this.data.totalAmount;
      } else {
        this.freeAmount += 0.50;
      }
      this.freeAmount = this.roundedThisNumber(this.freeAmount);
    }
  }

  onFreeAmountChange(): void {
    if (this.freeAmount > this.data.totalAmount) {
      this.freeAmount = this.data.totalAmount;
    } else if (this.freeAmount < 0.00) {
      this.freeAmount = 0.00;
    }
  }

  onConfirm(): void {
    this.selectedOption = this.freeAmount;
    this.isClosing = true;
  }

  onCancel() {
    this.selectedOption = null;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
